module.exports = __webpack_public_path__ + "img/0.8f52f376.png";